import { Dictionary } from '@reduxjs/toolkit'
import { removeDoubleQuotes } from 'components/no-ui/string-formatting'
import { AppUserValue } from 'lib/actions/apps/app-users'
import { Value } from 'pbts/google/protobuf/struct'

export const getAppUserProfileFieldValue = (appUser: AppUserValue, attributeKey: string): string => {
    const fields: Dictionary<Value> = {}
    if (!appUser.profile) {
        return ''
    }
    Object.entries(appUser.profile.fields).forEach(([key, value]) => {
        fields[key] = value
    })

    const val = fields[attributeKey]

    if (!val) {
        return ''
    }

    return removeDoubleQuotes(Value.toJsonString(val))
}

export * from './ProfileList'
export * from './AppUserProfile'
export * from './AppUserDetails'
